export const enAccountSelectorTranslations = {
    ACCOUNT_SELECTOR__SELECT_ACCOUNT: 'Select',
    ACCOUNT_SELECTOR__FETCH_ERROR: 'Failed to load accounts, try again later',
    ACCOUNT_SELECTOR__GRANTS_INVALID: 'Not all access rights have been granted for this account.',
    ACCOUNTS__SUBHEADER: 'Link social media accounts',
    ACCOUNTS__REMOVE_ACCOUNT: 'Unlink',
    ACCOUNTS__REMOVE__SUCCESS: 'Account successfully removed',
    ACCOUNTS__REMOVE__ERROR: 'Error occurred while removing account',
};
